// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-bar {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  position: relative;
}

.tab-item {
  display: flex;
width: 180px;
height: 40px;
margin-top: 24px;
max-width: 189px;
max-height: 56px;
padding: 12px 16px;
justify-content: center;
align-items: center;
gap: 8px;
border-radius: 8px;
border: 1px solid var(--Neutral-300, #CBD5E1);
opacity: 0.5;
background: var(--Neutral-50, #F8FAFC);
flex: 1 0;
color: var(--Neutral-700, #334155);
text-align: center;
font-feature-settings: 'liga' off, 'clig' off;
font-family: Inter;
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 16px; /* 133.333% */
  /* display: flex;
  width: 136px;
  height: 40px;
  max-width: 189px;
  max-height: 56px;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid var(--Neutral-300, #CBD5E1);
  opacity: 0.5;
  background: var(--Neutral-50, #F8FAFC);
  position: relative; 
  z-index: 1; Ensure tab is above the progress bar */
}

.tab-item.active {
  display: flex;
  width: 180px;
  height: 40px;
  max-width: 189px;
  max-height: 56px;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid var(--Primary-300, #74E1B4);
  background: var(--Primary-50, #EDFCF5);
  opacity: 1; 
}
.tab-item.iscompleted {
  border-radius: 8px;
  border: 1px solid var(--Primary-300, #74E1B4);
  background: var(--Primary-50, #e4fbf0);
}

.task-progress-container {
  display:flex;
  position: absolute; 
  left: 50%;
  transform: translateX(-50%); 
  bottom: -12px;
  width: 40%; 
  height: 8px;
  background-color: #E2E8F0;
  z-index: 1; 
  border-radius: 4px; 
}

.tab-item.active + .task-progress-container {
  display: flex; 
}

.task-progress-container {
  display: none; 
  align-items: center;
  justify-content: flex-start; 
}

.task-progress-bar {
  height: 100%;
  background-color: #3CCB94;
  width: 0%;
  border-radius: 4px; 
  transition: width 0.3s ease;
}

.task-progress-bar {
  height: 100%;
  background-color: #3CCB94; 
  width: 0%;
  transition: width 0.3s ease;
}

.check-icon-inline {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}
@media (max-width: 1158px) {
  .toppart{
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.25rem;
    padding: 0.5rem;
    text-align: center;
  }
  
  .breadcrumb {
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.25rem;
    padding: 0.5rem;
    text-align: center;
  }

  .breadcrumb-element1,
  .breadcrumb-element2,
  .breadcrumb-element3 {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
  }

  .element-text,
  .element-text3,
  .overline {
    font-size: 0.65rem;
    line-height: 1rem;
    white-space: nowrap;
  }

  .toppart {
    flex-direction: column;
    padding: 1rem;
    align-items: flex-start;
    text-align: center;
  }
}

@media (max-width: 600px) {
 
  .tab-bar {
    flex-direction: column; 
    align-items: center;
  }

  .bar-tab-completed {
    border-radius: 8px;
    border: 1px solid var(--Primary-300, #74e1b4);
    background: var(--Primary-50, #edfcf5);
  }
  .tab-item {
    width: 90%; 
    margin-bottom: 0.5rem; 
    flex: 0 0 auto;
  }
  .task-progress-container{
        margin-top: 1.25rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/screens/Assessment/Components/Tab-bar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf,YAAY;AACZ,YAAY;AACZ,gBAAgB;AAChB,gBAAgB;AAChB,gBAAgB;AAChB,kBAAkB;AAClB,uBAAuB;AACvB,mBAAmB;AACnB,QAAQ;AACR,kBAAkB;AAClB,6CAA6C;AAC7C,YAAY;AACZ,sCAAsC;AACtC,SAAW;AACX,kCAAkC;AAClC,kBAAkB;AAClB,6CAA6C;AAC7C,kBAAkB;AAClB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,aAAa;EAC9B;;;;;;;;;;;;;;oDAckD;AACpD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6CAA6C;EAC7C,sCAAsC;EACtC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;;;IAGE,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;;;IAGE,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;;EAEE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,6CAA6C;IAC7C,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,qBAAqB;IACrB,cAAc;EAChB;EACA;QACM,mBAAmB;IACvB;AACJ","sourcesContent":[".tab-bar {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n  position: relative;\n}\n\n.tab-item {\n  display: flex;\nwidth: 180px;\nheight: 40px;\nmargin-top: 24px;\nmax-width: 189px;\nmax-height: 56px;\npadding: 12px 16px;\njustify-content: center;\nalign-items: center;\ngap: 8px;\nborder-radius: 8px;\nborder: 1px solid var(--Neutral-300, #CBD5E1);\nopacity: 0.5;\nbackground: var(--Neutral-50, #F8FAFC);\nflex: 1 0 0;\ncolor: var(--Neutral-700, #334155);\ntext-align: center;\nfont-feature-settings: 'liga' off, 'clig' off;\nfont-family: Inter;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 16px; /* 133.333% */\n  /* display: flex;\n  width: 136px;\n  height: 40px;\n  max-width: 189px;\n  max-height: 56px;\n  padding: 12px 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 8px;\n  border: 1px solid var(--Neutral-300, #CBD5E1);\n  opacity: 0.5;\n  background: var(--Neutral-50, #F8FAFC);\n  position: relative; \n  z-index: 1; Ensure tab is above the progress bar */\n}\n\n.tab-item.active {\n  display: flex;\n  width: 180px;\n  height: 40px;\n  max-width: 189px;\n  max-height: 56px;\n  padding: 12px 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 8px;\n  border: 1px solid var(--Primary-300, #74E1B4);\n  background: var(--Primary-50, #EDFCF5);\n  opacity: 1; \n}\n.tab-item.iscompleted {\n  border-radius: 8px;\n  border: 1px solid var(--Primary-300, #74E1B4);\n  background: var(--Primary-50, #e4fbf0);\n}\n\n.task-progress-container {\n  display:flex;\n  position: absolute; \n  left: 50%;\n  transform: translateX(-50%); \n  bottom: -12px;\n  width: 40%; \n  height: 8px;\n  background-color: #E2E8F0;\n  z-index: 1; \n  border-radius: 4px; \n}\n\n.tab-item.active + .task-progress-container {\n  display: flex; \n}\n\n.task-progress-container {\n  display: none; \n  align-items: center;\n  justify-content: flex-start; \n}\n\n.task-progress-bar {\n  height: 100%;\n  background-color: #3CCB94;\n  width: 0%;\n  border-radius: 4px; \n  transition: width 0.3s ease;\n}\n\n.task-progress-bar {\n  height: 100%;\n  background-color: #3CCB94; \n  width: 0%;\n  transition: width 0.3s ease;\n}\n\n.check-icon-inline {\n  width: 16px;\n  height: 16px;\n  margin-right: 5px;\n}\n@media (max-width: 1158px) {\n  .toppart{\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 0.25rem;\n    padding: 0.5rem;\n    text-align: center;\n  }\n  \n  .breadcrumb {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 0.25rem;\n    padding: 0.5rem;\n    text-align: center;\n  }\n\n  .breadcrumb-element1,\n  .breadcrumb-element2,\n  .breadcrumb-element3 {\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 0.25rem;\n  }\n\n  .element-text,\n  .element-text3,\n  .overline {\n    font-size: 0.65rem;\n    line-height: 1rem;\n    white-space: nowrap;\n  }\n\n  .toppart {\n    flex-direction: column;\n    padding: 1rem;\n    align-items: flex-start;\n    text-align: center;\n  }\n}\n\n@media (max-width: 600px) {\n \n  .tab-bar {\n    flex-direction: column; \n    align-items: center;\n  }\n\n  .bar-tab-completed {\n    border-radius: 8px;\n    border: 1px solid var(--Primary-300, #74e1b4);\n    background: var(--Primary-50, #edfcf5);\n  }\n  .tab-item {\n    width: 90%; \n    margin-bottom: 0.5rem; \n    flex: 0 0 auto;\n  }\n  .task-progress-container{\n        margin-top: 1.25rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
